import React, { useCallback } from 'react';
import { AceEditorComponent } from '../AceSpaceBro.js';
import MarkdownRenderer from '../../utils/markdownRenderer.js';

const ChatMessage = ({ 
  message, 
  isUserMessage, 
  index, 
  windowWidth, 
  isDarkMode, 
  styles, 
  streamingCodeBlocks 
}) => {

  const renderChatSegment = useCallback(
    (segment, index, isUserMessage) => {
      // Check if this segment includes a complete code block
      const isFullCodeBlock = /```[\s\S]*?```/.test(segment);

      // Handle streaming blocks that aren't complete yet
      if (streamingCodeBlocks[index] && !isFullCodeBlock) {
        const { language, content, blockStart } = streamingCodeBlocks[index];
        const textBeforeBlock = segment.slice(0, blockStart);

        return (
          <div className="message-segments">
            {textBeforeBlock && (
              <div
                className="message-content"
                style={{
                  ...(isUserMessage ? styles.userMessage : styles.botMessage),
                  margin: '8px 0',
                }}
              >
                {textBeforeBlock}
              </div>
            )}
            <div
              style={{
                position: 'relative',
                width: `${100 + (1 / (windowWidth / 500)) * 5}%`,
                marginLeft: '-4px',
              }}
            >
              <AceEditorComponent
                key={`editor-${index}-${content.length}`}
                code={content}
                type={language || 'python'}
                isDarkMode={isDarkMode}
                isStreaming={true}
              />
            </div>
          </div>
        );
      }

      // Process completed code blocks
      const parts = [];
      let currentPos = 0;
      const codeBlockRegex = /```(\w+)?\n?([\s\S]*?)```/g;
      let match;

      while ((match = codeBlockRegex.exec(segment)) !== null) {
        // Add text before the code block
        if (match.index > currentPos) {
          parts.push({
            type: 'text',
            content: segment.slice(currentPos, match.index),
          });
        }

        // Add the code block
        parts.push({
          type: 'code',
          language: match[1] || 'text',
          content: match[2],
        });

        currentPos = match.index + match[0].length;
      }

      // Add remaining text after the last code block
      if (currentPos < segment.length) {
        parts.push({
          type: 'text',
          content: segment.slice(currentPos),
        });
      }

      // If no code blocks were found, treat the entire segment as text
      if (parts.length === 0) {
        parts.push({
          type: 'text',
          content: segment,
        });
      }

      return (
        <div className="message-segments">
          {parts.map((part, partIndex) => {
            if (part.type === 'code') {
              return (
                <div
                  key={`${index}-${partIndex}`}
                  style={{
                    position: 'relative',
                    width: `${100 + (1 / (windowWidth / 500)) * 5}%`,
                    marginLeft: '-4px',
                  }}
                >
                  <AceEditorComponent
                    key={`editor-${index}-${partIndex}`}
                    code={part.content}
                    type={part.language}
                    isDarkMode={isDarkMode}
                    isStreaming={false}
                  />
                </div>
              );
            }

            return (
              <div
                key={`${index}-${partIndex}`}
                className="message-content"
                style={{
                  ...(isUserMessage ? styles.userMessage : styles.botMessage),
                }}
              >
                <MarkdownRenderer content={part.content} />
              </div>
            );
          })}
        </div>
      );
    },
    [windowWidth, isDarkMode, styles, streamingCodeBlocks]
  );

  return (
    <div key={index}>
      {renderChatSegment(message, index, isUserMessage)}
    </div>
  );
};

export default ChatMessage; 